<template>
  <div>
    <!-- Background filter -->
    <transition name="fade" mode="out-in">
      <div v-show="show"
           :class="{'fullscreen-img-background': true, unclickable: !show}"
           @click="show = false"></div>
    </transition>
    <!-- Fullscreen Image -->
    <transition name="fade-fullscreen-img" mode="out-in">
      <div v-show="show"
           ref="fullscreenImg"
           v-lazy:background-image="fullscreenImg"
           :class="{'fullscreen-img': true, unclickable: !show}"
           @click="show = false"></div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      fullscreenImg: null
    }
  },
  methods: {
    setFullscreenImg (urls, event) {
      var style = this.$refs.fullscreenImg.style
      var imgRect = event.target.getBoundingClientRect()
      style.transition = 'none'
      style.top = imgRect.y + 'px'
      style.left = imgRect.x + 'px'
      style.height = imgRect.height + 'px'
      style.width = imgRect.width + 'px'
      style['background-image'] = 'none'
      setTimeout(() => {
        style.transition = '1s'
        style.top = '0'
        style.left = '0'
        style.height = '100vh'
        style.width = '100vw'
      }, 100)
      this.fullscreenImg = urls
      this.show = true
    }
  },
  beforeMount () {
    this.$fullscreenImg.$on('set', this.setFullscreenImg)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FullscreenImg.vue